'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAppPath = getAppPath;
exports.default = path;

var _startsWith = require('lodash/startsWith');

var _startsWith2 = _interopRequireDefault(_startsWith);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appPath = null;

function getAppPath() {
    return appPath || (appPath = resolveAppPath());
}

function resolveAppPath() {
    var tag = window && window.document.head.querySelector("meta[name='app-path']");
    return tag && tag.content || '/';
}

function path(relativeUrl) {
    var url = getAppPath();

    if (typeof relativeUrl === 'string' && relativeUrl.length > 0) {
        if ((0, _startsWith2.default)(relativeUrl, '~/')) {
            url += relativeUrl.substr(2);
        } else if ((0, _startsWith2.default)(relativeUrl, '/')) {
            url += relativeUrl.substr(1);
        } else {
            url += relativeUrl;
        }
    }
    return url;
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/core/appPath.js
// module id = 255
// module chunks = 0